<template>
  <transition name='fade'>
    <!-- 蒙版 -->
    <div class="mask"  v-if="show" @touchmove.prevent>
      <div class="window">
        <img class="shadow" :src="imgUrl" alt="">
        <p>{{content}}</p>
      </div>
      <div @click="show = false" class="close"><img src="../../static/img/qiye/iconn19.png"></div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'app',
  data () {
    return {
      show: false,
      imgUrl: '',
      title: '',
      content: '',
      btnText: '',
      click: ''
    }
  },
  created () {
	  var that = this;
	  setTimeout(function(){
	  	that.show = false;
	  },2000)
  },
  methods(){
	
  },
  methods: {
    btnClick () {
      this.click()
      this.show = false;
    }
  }
}
</script>
<style>
	
</style>


// WEBPACK FOOTER //
// src/components/Popup.vue